import React from "react";

export default function CodCollect({
  codAmount,
  onCodAmountChange,
  codMethod,
  onCodMethodChange,
  onRecordCod,
  updating,
  targetAmount,
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5 space-y-4 shadow-sm">
      <div className="text-center space-y-1">
        <h3 className="font-bold text-gray-900 text-base">
          Record Cash Collection
        </h3>
        <p className="text-xs text-gray-500">
          Target collection amount: ${parseFloat(targetAmount || 0).toFixed(2)}
        </p>
      </div>

      <div className="space-y-3">
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">
            Amount Collected ($)
          </label>
          <input
            type="number"
            step="0.01"
            value={codAmount}
            onChange={(e) => onCodAmountChange(e.target.value)}
            placeholder="0.00"
            className="w-full px-4 py-3 rounded-xl border border-gray-300 font-bold text-lg text-gray-900 focus:ring-2 focus:ring-amber-500 focus:outline-none"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">
            Payment Method
          </label>
          <div className="grid grid-cols-2 gap-2">
            {[
              ["cash", "Cash USD"],
              ["ecocash", "EcoCash"],
            ].map(([val, label]) => (
              <button
                key={val}
                type="button"
                onClick={() => onCodMethodChange(val)}
                className={`py-2.5 rounded-xl border text-xs font-semibold ${
                  codMethod === val
                    ? "border-amber-500 bg-amber-50 text-amber-900"
                    : "border-gray-200 text-gray-600 hover:bg-gray-50"
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={onRecordCod}
        disabled={updating || !codAmount || parseFloat(codAmount) <= 0}
        className="w-full py-3.5 rounded-xl bg-amber-600 text-white font-bold text-sm hover:bg-amber-700 active:scale-95 transition-all disabled:opacity-50"
      >
        {updating ? "Recording..." : "Confirm Collection"}
      </button>
    </div>
  );
}
